var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAward5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_432_4088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8925 2.23318L18.3526 9.2619L27.3359 10.5696L20.8342 16.9231L22.3657 25.892L14.3324 21.6563L6.29912 25.892L7.83062 16.9231L1.33594 10.5696L10.3193 9.2619L13.7794 2.23318C14.0062 1.77123 14.6656 1.77123 14.8925 2.23318Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7789 7.64836L16.807 9.73068C17.041 10.2068 17.4948 10.5338 18.0195 10.6119L20.3167 10.946C21.6355 11.1378 22.1673 12.7653 21.2101 13.6963L19.551 15.3167C19.1681 15.6863 18.9979 16.2193 19.0901 16.7452L19.48 19.0336C19.7069 20.3555 18.3243 21.3576 17.1474 20.7322L15.0912 19.6519C14.6232 19.4032 14.0631 19.4032 13.5951 19.6519L11.539 20.7322C10.3549 21.3576 8.97937 20.3484 9.20626 19.0336L9.59622 16.7452C9.68839 16.2193 9.51114 15.6863 9.13535 15.3167L7.47623 13.6963C6.51905 12.7653 7.05082 11.1378 8.3696 10.946L10.6668 10.6119C11.1915 10.5338 11.6453 10.2068 11.8793 9.73068L12.9074 7.64836C13.4959 6.44729 15.2046 6.44729 15.7931 7.64836H15.7789Z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_432_4088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white",
    transform: "translate(1.33594 1.88477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAward5);
export default __webpack_public_path__ + "static/media/icAward5.a4e4169270691f45658ca51bece03fc7.svg";
export { ForwardRef as ReactComponent };